export class ProgrammeMember {
    id: number;
    user_id: number;
    programme_id: number;
    constructor(programmeMember?) {
        if (programmeMember) {
            this.id = programmeMember.id;
            this.user_id = programmeMember.user_id;
            this.programme_id = programmeMember.programme_id;
        }
    }
}
